export const blobToBase64 = (blobUrl: string) => fetch(blobUrl)
  .then((response) => response.arrayBuffer())
  .then((data) => {
    const base64String = btoa(String.fromCharCode.apply(null, new Uint8Array(data)));

    return `data:image/jpeg;base64,${base64String}`;
  });
